import { Stack, Text } from "flicket-ui";
import { DeliveryOptions } from "~components/checkout/checkout.DeliveryOptions";
import { useCheckoutContext } from "~context/checkoutContext";
import { useOrganization, useSDK } from "~hooks";
import { OrderSummaryContext } from "../OrderSummary/OrderSummaryContext";
import { useContext, useEffect, useState } from "react";
import { showToast } from "~lib/helpers/showToast";
import { useFormikContext } from "formik";
import { SinglePageCheckoutFormValues } from "~features/single-page-checkout/forms/useSinglePageCheckoutForm";

export const SinglePageCheckoutDeliveryBlock = () => {
  const { addToQueue, isLoading } = useContext(OrderSummaryContext);
  const { isSubmitting } = useFormikContext<SinglePageCheckoutFormValues>();
  const { organization } = useOrganization();
  const { smsConfirmation, order } = useCheckoutContext();
  const [value, setValue] = useState<"sms" | "digital">(
    order?.smsConfirmationAmount > 0 ? "sms" : "digital"
  );
  const sdk = useSDK();

  const onChangeDeliveryOption = (value: "sms" | "digital") => {
    setValue(value);

    addToQueue(`delivery-option`, async () => {
      try {
        await sdk.updateOrder({
          id: order?.id,
          input: {
            sendSmsConfirmation: value === "sms",
            step: 3,
          },
        });
      } catch (error) {
        showToast("Failed to update delivery option", "error");
        console.error("Failed to update delivery option:", error);
      }
    });
  };

  // This is in case there was an error applying the delivery option and we need to reset the value
  useEffect(() => {
    if (!isLoading) {
      setValue(order?.smsConfirmationAmount > 0 ? "sms" : "digital");
    }
  }, [isLoading, setValue]);

  return (
    !!smsConfirmation?.fee && (
      <Stack direction={"vertical"}>
        <DeliveryOptions
          organization={organization}
          smsConfirmation={smsConfirmation}
          label={<Text variant="header.S">Delivery options</Text>}
          value={value}
          onChange={onChangeDeliveryOption}
          disabled={isSubmitting}
        />
      </Stack>
    )
  );
};
